import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/home',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'HomeIndex',
        component: () => import('@/views/home/index'),
        meta: { title: '首页', icon: 'el-icon-s-home', menuKey: 'home.index' }
      },
      {
        path: 'big-screen',
        name: 'HomeBigScreen',
        component: () => import('@/views/home/big-screen'),
        meta: { title: '爆破数据大屏', icon: 'el-icon-full-screen', viewKey: 'blast_screen.view' },
        hidden: true
      }
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    redirect: '/statistics/blast',
    meta: { title: '数据统计', icon: 'el-icon-data-analysis', alwaysShow: true },
    children: [
      {
        path: 'blast',
        name: 'StatisticsBlast',
        component: () => import('@/views/statistics/index'),
        meta: { title: '爆破统计', statType: 'work', menuKey: 'statistics.work' }
      },
      {
        path: 'production',
        name: 'StatisticsProduction',
        component: () => import('@/views/statistics/production'),
        meta: { title: '生产统计', menuKey: 'statistics.production' }
      }
    ]
  },
  {
    path: '/full-chain',
    component: Layout,
    redirect: '/full-chain/overview',
    meta: { title: '全链路管理', icon: 'el-icon-connection', alwaysShow: true },
    children: [
      {
        path: 'overview',
        name: 'FullChainOverview',
        component: () => import('@/views/full-chain/overview'),
        meta: { title: '全链路总览', menuKey: 'full_chain.overview' }
      },
      {
        path: 'trace',
        name: 'FullChainTrace',
        component: () => import('@/views/full-chain/trace'),
        meta: {
          title: '雷管全链路追溯',
          menuKey: 'full_chain.trace'
        }
      },
      {
        path: 'screen',
        name: 'FullChainScreen',
        component: () => import('@/views/full-chain/screen'),
        meta: {
          title: '全链路数据大屏',
          viewKey: 'full_chain_screen.view'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/operations',
    component: Layout,
    redirect: '/operations/work',
    meta: { title: '爆破管理', icon: 'el-icon-odometer', alwaysShow: true },
    children: [
      {
        path: 'authorization',
        name: 'AuthorizationList',
        component: () => import('@/views/authorization/list'),
        meta: { title: '授权管理', menuKey: 'operations.authorization' },
        hidden: true
      },
      {
        path: 'work',
        name: 'BlastRecordList',
        component: () => import('@/views/blast-record/list'),
        meta: { title: '作业管理', menuKey: 'operations.work' }
      },
      {
        path: 'exceptions',
        name: 'BlastExceptionList',
        component: () => import('@/views/blast-record/exceptions'),
        meta: { title: '异常处理中心', menuKey: 'operations.work' },
        hidden: true
      },
      {
        path: 'detonators',
        name: 'DetonatorList',
        component: () => import('@/views/detonator/list'),
        meta: { title: '起爆器管理', menuKey: 'operations.detonators' }
      },
      {
        path: 'companies',
        name: 'BlastCompanyList',
        component: () => import('@/views/blast-company/list'),
        meta: { title: '爆破公司管理', menuKey: 'operations.companies' }
      },
      {
        path: 'blasters',
        name: 'AppBlasterList',
        component: () => import('@/views/app-blaster/list'),
        meta: { title: '爆破员管理', menuKey: 'operations.blasters' }
      },
      {
        path: 'wires',
        name: 'WireList',
        component: () => import('@/views/shared/coming-soon'),
        meta: {
          title: '雷管管理',
          menuKey: 'operations.wires',
          description: '后续补充雷管台账、重复雷管核验、流转记录和异常追踪能力。'
        },
        props: route => ({ title: route.meta.title, description: route.meta.description }),
        hidden: true
      },
      {
        path: 'offline-auth',
        name: 'OfflineAuthList',
        component: () => import('@/views/offline-auth/list'),
        meta: {
          title: '离线授权管理',
          menuKey: 'operations.offline_auth',
          description: '后续补充离线授权发放、回收、过期检查和设备授权记录查询。'
        }
      }
    ]
  },
  {
    path: '/production',
    component: Layout,
    redirect: '/production/records',
    meta: { title: '生产管理', icon: 'el-icon-office-building', alwaysShow: true },
    children: [
      {
        path: 'records',
        name: 'ProductionRecordList',
        component: () => import('@/views/production-record/list'),
        meta: { title: '管厂生产记录', menuKey: 'production.records' }
      },
      {
        path: 'clients',
        name: 'ProductionClientList',
        component: () => import('@/views/production-client/list'),
        meta: { title: '上传客户端管理', menuKey: 'production.clients' }
      },
      {
        path: 'screen',
        name: 'ProductionScreen',
        component: () => import('@/views/production-record/screen'),
        meta: {
          title: '生产数据大屏',
          viewKey: 'production_screen.view'
        },
        hidden: true
      }
    ]
  },
  {
    path: '/operations/work/detail/:id',
    component: Layout,
    children: [
      {
        path: '',
        name: 'BlastRecordDetail',
        component: () => import('@/views/blast-record/detail'),
        meta: { title: '作业记录详情', menuKey: 'operations.work' },
        hidden: true
      }
    ],
    hidden: true
  },
  {
    path: '/operations/exceptions/detail/:id',
    component: Layout,
    children: [
      {
        path: '',
        name: 'BlastExceptionDetail',
        component: () => import('@/views/blast-record/detail'),
        meta: { title: '异常作业详情', menuKey: 'operations.work' },
        hidden: true
      }
    ],
    hidden: true
  },
  {
    path: '/ops',
    component: Layout,
    redirect: '/ops/overview',
    meta: { title: '运维中心', icon: 'el-icon-monitor', alwaysShow: true },
    children: [
      {
        path: 'overview',
        name: 'OpsOverview',
        component: () => import('@/views/ops/overview'),
        meta: { title: '运行总览', menuKey: 'ops.overview' }
      },
      {
        path: 'events',
        name: 'OpsEvents',
        component: () => import('@/views/ops/events'),
        meta: { title: '接入日志', menuKey: 'ops.events' }
      },
      {
        path: 'alerts',
        name: 'OpsAlerts',
        component: () => import('@/views/ops/alerts'),
        meta: { title: '告警管理', menuKey: 'ops.alerts' }
      }
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/users',
    meta: { title: '系统管理', icon: 'el-icon-setting', alwaysShow: true },
    children: [
      {
        path: 'users',
        name: 'SystemUsers',
        component: () => import('@/views/system/users'),
        meta: { title: '用户管理', menuKey: 'system.users' }
      },
      {
        path: 'settings',
        name: 'SystemSettings',
        component: () => import('@/views/system/settings'),
        meta: { title: '系统设置', menuKey: 'system.settings' }
      },
      {
        path: 'permissions',
        name: 'SystemPermissions',
        component: () => import('@/views/system/permissions'),
        meta: { title: '权限配置', menuKey: 'system.permissions' }
      }
    ]
  },
  {
    path: '/',
    redirect: '/home/index',
    hidden: true
  }
]

const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export default router
